export const ErrorTypes = {
  INVALID_FIELD: 'invalid-field',
  ENCRYPT_ERROR: 'encrypt-error',
} as const;

export type ErrorData = {
  errorType: string;
  fieldType?: string;
  errorText: string;
};
